<template>
  <a-modal
      :title="`${actType}授权账号`"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showForm"
      :confirmLoading="loading"
      @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="账号名称" prop="name">
        <a-input v-model="model.name"/>
      </a-form-model-item>
      <a-form-model-item label="投放媒体" prop="media">
        <a-select show-search option-filter-prop="children" v-model="model.media" @change="changeMedia" placeholder="请选择">
          <a-select-option :value="media.id" v-for="media in medias" :key="media.id">
            {{ media.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="[2].includes(model.media)" label="代理商" prop="media_type">
        <a-select show-search option-filter-prop="children" v-model="model.media_type" placeholder="请选择">
          <a-select-option :value="item.id" v-for="item in mediaTypes" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <div v-if="[1, 2].includes(model.media)">
        <a-form-model-item label="AppID" prop="settings.app_id">
          <a-input v-model="model.settings.app_id" />
        </a-form-model-item>
        <a-form-model-item label="Secret" prop="settings.secret">
          <a-input v-model="model.settings.secret" />
        </a-form-model-item>
        <a-form-model-item label="Scope" prop="settings.scope">
          <a-input v-model="model.settings.scope" />
        </a-form-model-item>
      </div>

      <div v-if="[1,2].includes(model.media)">
        <a-form-model-item label="spi验证秘钥" prop="settings.spi_secret_key">
          <a-input v-model="model.settings.spi_secret_key" />
        </a-form-model-item>
      </div>

      
      <div v-if="model.media === 3">
        <a-form-model-item label="AppID" prop="settings.app_id">
          <a-input v-model="model.settings.app_id" />
        </a-form-model-item>
        <a-form-model-item label="SecretKey" prop="settings.secret_key">
          <a-input v-model="model.settings.secret_key" />
        </a-form-model-item>
        <a-form-model-item label="Scope" prop="settings.scope">
          <a-input v-model="model.settings.scope" />
        </a-form-model-item>
        <a-form-model-item label="AccessToken" prop="settings.app_access_token">
          <a-input type="textarea" :auto-size="{ minRows: 3, maxRows: 3 }" v-model="model.settings.app_access_token" />
        </a-form-model-item>
      </div>
      <div v-if="[4, 5].includes(model.media)">
        <a-form-model-item label="ClientId" prop="settings.client_id">
          <a-input v-model="model.settings.client_id" />
        </a-form-model-item>
        <a-form-model-item label="ClientSecret" prop="settings.client_secret">
          <a-input v-model="model.settings.client_secret" />
        </a-form-model-item>
      </div>
      <a-form-model-item v-if="super_or_main" label="开发者账号" prop="developer_account_id">
        <a-select allow-clear show-search option-filter-prop="children" v-model="model.developer_account_id" placeholder="请选择">
          <a-select-option :value="item.id" v-for="item in developerAccounts" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        v-if="[1].includes(model.media)"
        label="开放平台类型"
        prop="open_platform_type"
        help="短剧经营者平台请选择「短剧经营者」，scope 将自动使用 ad_series"
      >
        <a-select show-search option-filter-prop="children" v-model="model.open_platform_type" @change="changeOpenPlatformType" placeholder="请选择">
          <a-select-option :value="item.id" v-for="item in openPlatformTypes" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="[1].includes(model.media)" label="付费类型" prop="pay_type">
        <a-select allow-clear show-search option-filter-prop="children" v-model="model.pay_type" placeholder="请选择">
          <a-select-option :value="item.id" v-for="item in payTypes" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="[1].includes(model.media)" label="业务类型" prop="business_type">
        <a-select allow-clear show-search option-filter-prop="children" v-model="model.business_type" placeholder="请选择">
          <a-select-option :value="item.id" v-for="item in businessTypes" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="授权管理员" prop="admin_ids" help="授权后对应管理员可对该账号进行广告拉取操作">
        <a-select mode="multiple" placeholder="请选择" :default-value="model.admin_ids" v-model="model.admin_ids">
          <a-select-option :value="admin.id" v-for="admin in admins" :key="admin.id">
            {{ admin.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="启用" prop="enabled">
        <a-switch v-model="model.enabled"/>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :loading="loading" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'

export default Create
</script>
